// src/api/apiUrls.ts
// This file contains the API endpoint URLs used in the applications.
const apiUrls = {
    GetUserDetails:'api/v1/getUserDetail',
    FetchPlantDetails:'api/v1/fetchPlantDetails',
    FetchPoleDetails:'api/v1/fetchPoleDetails',
    FetchServerDetails:'api/v1/fetchServerDetails',
    CreateMeterV2:'api/v1/addMeterV2',
    FetchMeterListV2:'api/v1/getMeterListV2',
    GetAllUnassignedMeters: 'api/v1/getAllUnassignedMeters',
    EditMeterV2:'api/v1/editMeterV2',
    SearchData: 'api/v1/searchData',
    FetchMeterDetailsV1: 'api/v1/getMeterListV1',
    AddMeterV1:'api/v1/addMeterV1',
    FetchMeterWIPDetailsV1:'api/v1/viewWIPDetails',
    EditMeterV1:'api/v1/editMeterV1',
    bulkActiveArchiveMeters: 'api/v1/bulkActiveArchiveMeters',
    getMeterDetailsByID: '/api/v1/getMeterDetailsV1ByID/:meterId',
    HandlePermission: 'api/v1/handlePermission',
    BulkActiveMeters:'/api/v1/bulkactivearchivemeters',
    FetchCountries: 'api/v1/getCountry',
    FetchStatesbyCountryId: 'api/v1/getStates',
    FetchNocsbyStateId: 'api/v1/getNocs',
    FetchPlantbyNocId: 'api/v1/getPlants',
    DeleteMeterDetails: 'api/v1/deleteMeterV1',
    DissociateMeter: 'api/v1/dissociateMeter',
    GetCashRechargeDetails: 'api/v1/GetCashRechargeDetails',
    GetRealtimeBalance: 'api/v1/GetRealtimeBalance',
    CalculateRechargeAmount: 'api/v1/CalculateRechargeAmount',
    VerifyCashPayment: 'api/v1/VerifyCashPayment',
    CreateCashPayment: 'api/v1/CreateCashPayment',
    GetCustomerDetails: 'api/v1/getCustomerDetails',
    ApplyCouponCode: 'api/v1/ApplyCoupon',
    AuthenticateAndSendOTP:'api/v1/authenticateAndSendOTP',
    VerifyOTP: 'api/v1/verifyOTP',
    ResendOTP: 'api/v1/resendOTP',
    NigeriaBulkNotificationUpdate:'api/v1/bulkNotificationUpdate',
    GetTransactionDataByOrderId: 'api/v1/GetTransactionDataByOrderId',
    RefundTransaction: '/api/v1/CreateRefund',
    SendBulkSMS:'api/v1/bulkSMSUpload',
    DownloadTemplate: 'api/v1/download-template',
    ImportCashPaymentData: '/api/v1/importFiles',
    GetManualCashPaymentDataList: 'api/v1/getManualCashPaymentDataList',
    GetManualCashPaymentDownloadStatusById: 'api/v1/getManualCashPaymentDownloadStatusById',
    // Transaction APIs
    GetTransactionsData: 'api/v1/getTransactionsList',
    GetTransactionsAnalytics: 'api/v1/getTransactionsAnalytics',
    FetchReportsDetails: 'api/v1/exports',
    // Ugx/UGX Token API
    GenerateUgxToken: 'api/v1/generateUgxToken',
    // WIP Transaction APIs
    GetWIPTransactionsList: 'api/v1/getWIPTransactionsList',
    GetProcessRemarksByOrderId: 'api/v1/getProcessRemarksByOrderId',
    // Cash Payments APIs
    GetCashPaymentsList: 'api/v1/getCashPaymentsList',
    GetTariffPlanChangeDetails: "api/v1/getTariffPlanChangeDetails",
    SaveTariffPlanChange: "api/v1/saveTariffPlanChange",
};

export default apiUrls;
